export default __webpack_public_path__ + "static/media/Aussois_2024_RobustRL.849ec478.pdf";